type AddressNameFragment = { street1?: string; poBox?: string };

export const getAddressFirstLine = (address: AddressNameFragment) => {
  let a = address as any;
  return a.street1 || `PO Box ${a.poBox}`;
};
